import { authFetch } from 'auth/utils';
import { FEATURE_FLAGS_MODULES, FeatureFlagsModules } from './FeatureFlags.models';
import { envVariables } from 'src/common/utils/envVariables';
import { keyBy, mapValues } from 'lodash';

type FeatureFlagsDTO = {
  featureFlags: Record<string, boolean>;
};

export const getFeatureFlags = async (signal?: AbortSignal) => {
  const simInventoryFeatureFlagsResponse = await authFetch(
    `${envVariables.VITE_SIM_INVENTORY_FEATURE_FLAGS_API}`,
    {
      signal,
    },
  );

  const featureFlags: Record<FeatureFlagsModules, Record<string, boolean>> = {
    [FEATURE_FLAGS_MODULES.SIM_INVENTORY]: {},
    [FEATURE_FLAGS_MODULES.BULK_PROVISIONING]: {},
    [FEATURE_FLAGS_MODULES.AUDIT_TRAIL]: {},
  };

  try {
    const simInventoryFeatureFlags: FeatureFlagsDTO = await simInventoryFeatureFlagsResponse.json();

    featureFlags[FEATURE_FLAGS_MODULES.SIM_INVENTORY] = mapValues(
      keyBy(simInventoryFeatureFlags.featureFlags, 'name'),
      'isEnabled',
    );
  } catch {
    featureFlags[FEATURE_FLAGS_MODULES.SIM_INVENTORY] = {};
  }

  try {
    const bulkFeatureFlagsResponse = await authFetch(
      `${envVariables.VITE_BULK_PROVISIONING_PROVISIONING_FEATURE_FLAGS_API}`,
      {
        signal,
      },
    );
    const bulkFeatureFlags: FeatureFlagsDTO = await bulkFeatureFlagsResponse.json();

    featureFlags[FEATURE_FLAGS_MODULES.BULK_PROVISIONING] = bulkFeatureFlags.featureFlags;
  } catch {
    featureFlags[FEATURE_FLAGS_MODULES.BULK_PROVISIONING] = {};
  }

  try {
    const auditTrailFeatureFlagsResponse = await authFetch(
      `${envVariables.VITE_AUDIT_TRAIL_FEATURE_FLAGS_API}`,
      {
        signal,
      },
    );

    const auditTrailFlags: FeatureFlagsDTO = await auditTrailFeatureFlagsResponse.json();

    featureFlags[FEATURE_FLAGS_MODULES.AUDIT_TRAIL] = mapValues(
      keyBy(auditTrailFlags.featureFlags, 'name'),
      'isEnabled',
    );
  } catch {
    featureFlags[FEATURE_FLAGS_MODULES.AUDIT_TRAIL] = {};
  }

  return featureFlags;
};
